export default {
    data() {
        return {
            activesite: 'compounding',
        };
},
    created() {
        this.checkTPN();
    },
    methods: {
        isTPN() {
            const currentUrl = window.location.href;
            return (currentUrl.includes('/#/tpn'));
        },
        checkTPN() {
            if (this.isTPN()) {
                this.activesite = 'nutrition';
            } else {
                this.activesite = 'compounding';
            }
        },
    },
    watch: {
        $route() {
            this.checkTPN();
        },
    },
};
